import {
  collection as dmnRevisionInfoCollection,
  schema as dmnRevisionSchema,
  fetch as fetchDmnRevisionInfo,
} from './dmnRevisionInfo'
import {
  create as createDmnUpdateRevision,
  schema as dmnReUpdateRevisionSchema,
  collection as dmnUpdateRevisionCollection,
} from './dmnUpdateRevision'

export * as DMN_MODEL_INFO from './dmnModelInfo'

export const DMN_REVISION_INFO = {
  collection: dmnRevisionInfoCollection,
  schema: dmnRevisionSchema,
  fetch: fetchDmnRevisionInfo,
}

export const DMN_UPDATE_REVISION = {
  collection: dmnUpdateRevisionCollection,
  schema: dmnReUpdateRevisionSchema,
  create: createDmnUpdateRevision,
}
